import { format } from "date-fns";
import { Save, Trash2, X } from "lucide-react";
import { Button } from "../../ui/button";

interface FormActionBarProps {
  recordId: number | null;
  lastSaved: Date | null;
  isSaving: boolean;
  onSave: () => void;
  onCancel: () => void;
  onDelete?: () => void;
}

export function FormActionBar({
  recordId,
  lastSaved,
  isSaving,
  onSave,
  onCancel,
  onDelete,
}: FormActionBarProps): React.ReactElement {
  return (
    <div className="flex items-center gap-4 shrink-0">
      <div className="flex items-center gap-1.5">
        <Button size="sm" onClick={onSave} disabled={isSaving} data-testid="save-button">
          <Save className="h-3.5 w-3.5" />
          {isSaving ? "Saving..." : "Save"}
        </Button>
        <Button size="sm" variant="ghost" onClick={onCancel} data-testid="cancel-button">
          <X className="h-3.5 w-3.5" />
          Cancel
        </Button>
        {recordId && onDelete && (
          <Button size="sm" variant="destructive" onClick={onDelete} data-testid="delete-button">
            <Trash2 className="h-3.5 w-3.5" />
            Delete
          </Button>
        )}
      </div>
      {lastSaved && <span className="text-xs text-muted-foreground">Last saved: {format(lastSaved, "h:mm a")}</span>}
    </div>
  );
}
